
import { defineComponent, Ref, ref, onMounted } from "vue";
import Api from "@/services/Api";
import {  useLoaderStore } from "@/store/LoaderStore";


interface VeiculoFiltroType {
  marca: string;
  modelo: string;
  fipe: string;
  anoInicial: string;
  anoFinal: string;
}

export default defineComponent({
  name: "ModalDownloadPlanilhaVeiculo",
  props: {
    fechaModal: Function,
  },

  setup(props) {

    const arquivo: Ref<any> = ref({});

    const modalDialogo: Ref<any> = ref();

    const mensagem: Ref<string> = ref('');

    const veiculoFiltro: Ref<VeiculoFiltroType> = ref({marca: "", modelo:"", fipe:"", anoInicial:"", anoFinal:""});

    const arrayMarcas: Ref<any[]> = ref([]);

    const loaderStore = useLoaderStore();

    const loadDownload = ref(false);

    function aplicaMascara() {
      veiculoFiltro.value.anoInicial = veiculoFiltro.value.anoInicial.replace(/\D/g, '').slice(0, 4);
      veiculoFiltro.value.anoFinal = veiculoFiltro.value.anoFinal.replace(/\D/g, '').slice(0, 4);
    }

    function closeModal(){
      arquivo.value = {};
      props.fechaModal && props.fechaModal();
    }


    function verificaAno(): boolean {

      const { anoInicial, anoFinal} = veiculoFiltro.value

      if(anoFinal && anoInicial > anoFinal) {

        mensagem.value = '*Ano inicial não pode ser maior que o ano final';
        return true

      }

      mensagem.value = ''
      return false

    }

    async function baixar() {

      loadDownload.value = true;

      if(verificaAno()) return;
      try{
        const response = await Api.get("downloadPlanilhaVeiculo", { ...veiculoFiltro.value }, { responseType: 'blob' });
        baixaArquivo(response, 'veiculos.csv');

      }catch(error) {
        console.error(error);
        loadDownload.value = false;
        return;
      }

      props.fechaModal && props.fechaModal()

      loadDownload.value = false;

    }

    function baixaArquivo(blobParam:any, name:string) {

      const url = URL.createObjectURL(new Blob([blobParam]));
      const link = document.createElement('a');
      link.href = url;
      link.download = name;
      link.click();
      URL.revokeObjectURL(url);

    }
    
    const getVehicleBrands = async() => arrayMarcas.value = (await Api.get('getAllvehicleBrand')).data.marcas

    onMounted(async()=>{

      getVehicleBrands()

    })
   
    return {
      baixar,
      arquivo,
      closeModal,
      arrayMarcas,
      modalDialogo,
      veiculoFiltro,
      verificaAno,
      aplicaMascara,
      mensagem,
      loadDownload
    };
  },
});
